<template>
  <svg height="65px" width="65px" viewBox="-10 -30 161 161" slot="activator">
    <title>DRIVER SEAT</title>
    <rect x="31" width="64.85" height="15.57" rx="7.39" fill="#00918d" />
    <rect x="31" y="104.43" width="64.85" height="15.57" rx="7.39" fill="#00918d" />
    <path
      d="M19.16,114.13l-.36.15-.37.16a6.8,6.8,0,0,1-5.76-.3,8.59,8.59,0,0,1-4.11-4.87,149.6,149.6,0,0,1,0-98.62,8.59,8.59,0,0,1,4.11-4.87,6.76,6.76,0,0,1,5.76-.29l.37.15.36.15a7.33,7.33,0,0,1,4,4.12,8.25,8.25,0,0,1,.13,5.86,134.27,134.27,0,0,0,0,88.38,8.25,8.25,0,0,1-.13,5.86A7.3,7.3,0,0,1,19.16,114.13Z"
      fill="#00918d"
    />
    <path
      d="M114.4,97.68a35.33,35.33,0,0,1-8.81-1.1A37.54,37.54,0,0,1,80.06,75.41a35.54,35.54,0,0,1-3.24-12.47L76.73,62l0-.47V58l0-.25s0-.09,0-.13a35.18,35.18,0,0,1,.89-6.34A38,38,0,0,1,99.48,25a36.83,36.83,0,0,1,11.08-2.91l1.56-.15.69-.06h3.47A26.91,26.91,0,0,0,98.35,9.37,10,10,0,0,1,88.46,18H38.4a10,10,0,0,1-5.57-1.69A40.7,40.7,0,0,0,22.61,26.65a131.67,131.67,0,0,0,0,66.29,40.67,40.67,0,0,0,10.18,10.34,10.05,10.05,0,0,1,5.57-1.69H88.46a10,10,0,0,1,9.89,8.59,27,27,0,0,0,18-12.57C115.68,97.64,115,97.68,114.4,97.68Z"
      fill="#00918d"
    />
    <path
      d="M99.09,42.6A22.49,22.49,0,0,0,92.8,52c.56-.09,1.12-.19,1.67-.32A24,24,0,0,0,106,45.82a17.2,17.2,0,0,0,5.11-8.34c.06-.22.11-.43.16-.65A22.24,22.24,0,0,0,99.09,42.6Z"
      fill="#00918d"
    />
    <path
      d="M98.31,69a26.3,26.3,0,0,0-5.5-1.46,23.23,23.23,0,0,0,18.43,15.2A16.15,16.15,0,0,0,108.09,76,22.19,22.19,0,0,0,98.31,69Z"
      fill="#00918d"
    />
    <path
      d="M113.6,24.86h3.06c.47,0,.94.1,1.41.13a32.8,32.8,0,0,1,7.61,1.51,34.55,34.55,0,0,1,19.7,15.92,35.08,35.08,0,0,1,3.82,24.82,35,35,0,0,1-31.62,27.34,32.59,32.59,0,0,1-10.73-.9A34.54,34.54,0,0,1,83.28,74.13a32.52,32.52,0,0,1-3-11.42c0-.48-.09-1-.13-1.45v-3a2.11,2.11,0,0,0,0-.35A32.05,32.05,0,0,1,81.06,52a35,35,0,0,1,20.13-24.24,33.9,33.9,0,0,1,10.18-2.68Zm10.24,10.37V84.3a26,26,0,0,0,0-49.07ZM115.13,86c-.06-.85-.09-1.65-.2-2.45a19.2,19.2,0,0,0-4-9.3,25.26,25.26,0,0,0-11.06-8,30,30,0,0,0-8.31-1.9c-.73-.07-1.47-.08-2.26-.12A26.09,26.09,0,0,0,98.09,79.6,25.69,25.69,0,0,0,115.13,86Zm0-52.37a25.67,25.67,0,0,0-17.51,6.8,26,26,0,0,0-8.23,15h.41a29.17,29.17,0,0,0,5.88-.71A27.08,27.08,0,0,0,108.53,48a20.39,20.39,0,0,0,6-9.76A18,18,0,0,0,115.09,33.58Zm0,30.54a4.36,4.36,0,1,0-4.33-4.38A4.33,4.33,0,0,0,115.07,64.12Z"
      fill="#58595b"
    />
  </svg>
</template>

<script>
export default {
  data() {
    return {};
  },
  beforeCreate: function() {},
  created() {},
  methods: {},
  computed: {}
};
</script>

<style scoped>
</style>
